import { render } from "./SessionHighlights.vue?vue&type=template&id=2640e88e"
import script from "./SessionHighlights.vue?vue&type=script&lang=js"
export * from "./SessionHighlights.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./SessionHighlights.vue?vue&type=style&index=0&id=2640e88e&module=true&lang=css"
cssModules["$style"] = style0

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__